import React, { Component } from 'react';
import './App.css';
import SliderBnA from 'react-bna';

import before from './assets/before.jpeg';
import after from './assets/after.jpeg';
import Form from './Components/Form/Form';



class App extends Component {

    constructor() {

        super();

        this.state = {

            showControls: true,
            showWidth: true,
            divisorBorder: true,

            imageHeight: 60,
            maxRange: 100,

            before,
            after,

            before_error: false, after_error: false, before_loaded: false, after_loaded: false,

            before_image_status: "loading", after_image_status: "loading"
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleValueChange = this.handleValueChange.bind(this);

        this.handleError = this.handleError.bind(this);
        this.handleLoaded = this.handleLoaded.bind(this);

    }

    handleInputChange({ target: { checked }, target: { name } }) {

        this.setState({ [name]: checked })

    }

    handleValueChange({ target: { value }, target: { name } }) {

        this.setState({
            [name]: value,
            [`${name}_error`]: false
        })

    }


    handleError(name) { console.log(name)
         this.setState({ [`${name}_image_status`]: "failed to load", [`${name}_loaded`]: false, [`${name}_error`]: true }) }

    handleLoaded(name) {
        this.setState(prevState => {

            return {

                [`${name}_loaded`]: true,

                [`${name}_image_status`]: prevState[`${name}_error`] === true ? "failed to load" : "Loaded"
            }


        })
    }


    componentDidUpdate(prevProps,prevState) {

        const { before_error} = this.state;

        if (prevState.before_error !== this.state.before_error) {

            this.setState({ before_error })

        }

    

    }

    render() {
        const { showControls, showWidth, imageHeight, divisorBorder, after, before

            , before_error, after_error, before_loaded, after_loaded, before_image_status, after_image_status

        } = this.state;



        return (

            <div id="display">

                <Form
                    showWidth={showWidth}
                    showControls={showControls}
                    imageHeight={imageHeight}
                    divisorBorder={divisorBorder}
                    before={before}
                    after={after}


                    handleValueChange={this.handleValueChange}
                    handleInputChange={this.handleInputChange}

                    imageStats={{ before_error, after_error, before_loaded, after_loaded, before_image_status, after_image_status }}

                />

                <SliderBnA

                    before={before}

                    after={after}

                    showControls={showControls}

                    showWidth={showWidth}

                    imageHeight={imageHeight}

                    divisorBorder={divisorBorder}

                    alt="React Before and after slider"

                    errorImage={"https://media.giphy.com/media/pyqqSHqdekwVi/giphy.gif"}

                    onErrorBefore={() => this.handleError("before")}

                    onErrorAfter={() => this.handleError("after")}

                    onLoadedBefore={() => this.handleLoaded("before")}

                    onLoadedAfter={() => this.handleLoaded("after")}

                />



            </div>



        )
    }

}

export default App;